import React, { useEffect, useRef, useState } from "react";
import { Button, Container, } from "react-bootstrap";
import { useNavigate, useParams } from "react-router-dom";
import "./translations.css";
import Loading from "../../components/ui/loader/loader";
import { useDispatch } from "react-redux";
import { recentViewAction, viewTranslateBatchDocAction } from "../../redux/actions/translateAction";
import errorToast from "../../components/toast/errorToast";
import DocFileViewer from "../../components/ui/viewer/docViewer";
import TranslatedDocFileViewer from "../../components/ui/viewer/translatedViewer";
import TranslationLayout from "../../components/ui/layouts/translate-layout";
import { availableLanguages } from "../../components/data/language";
import downloadIcon from "../../assets/icons/downloads.png";
import { ImGoogleDrive } from "react-icons/im";
import successToast from "../../components/toast/successToast";
import GoogleDrivePicker from "../../components/buttons/googleDrive";
import LoaderModal from "../../components/ui/Modal/loaderModal";
import { saveAs } from 'file-saver';
import { useAuth } from '../../context/AuthContext';

/** preview page  -> previewing files*/
const PreviewDocuments = () => {
    const [loading, setLoading] = useState(false);
    const [sourceFile, setSourceFile] = useState(null);
    const [translatedDataUrl, setTranslatedDataUrl] = useState(null);
    const [fileData, setFileData] = useState(null);
    const fileTypeRef = useRef(null);
    const [token, setAccessToken] = useState(null)
    const accessToken = localStorage.getItem('driveAccessToken') || null;
    const [showLoader, setShowLoader] = useState(false)

    const dispatch = useDispatch();
    const navigate = useNavigate()
    const { id } = useParams();
    const { portalId } = useAuth();

    useEffect(() => {
        if (id) {
            setLoading(true);
            dispatch(recentViewAction(id, onSuccess, onError));
        }
        if (localStorage.getItem('logout') === 'true') {
            navigate(`/login/${portalId}`)
        }
    }, [id, dispatch]);


    const onSuccess = (data) => {
        console.log(data.data.data, "file data");

        setSourceFile(data.data.data.sourceSignedUrl);
        setFileData(data.data.data)
        const fileUrlType = data.data.data.source_url.split('.')[3];
        fileTypeRef.current = fileUrlType;
        const dispatchingData = {
            fileUri: data.data.data.is_glossary ? data.data.data.glossary_url : data.data.data.translated_url
        }
        dispatch(viewTranslateBatchDocAction(dispatchingData, onViewDocSuccess, onViewDocError));
    };

    const onError = (data) => {
        setLoading(false);
        navigate('/recent-translations')
        errorToast(data.data.message);
    };

    const createDataUrl = (buffer, fileType) => {
        const uint8Array = new Uint8Array(buffer);
        const blob = new Blob([uint8Array], { type: `application/${fileType}` });
        return URL.createObjectURL(blob);
    };

    const onViewDocSuccess = (data) => {
        const url = data.data.data;
        if (fileTypeRef.current === "pdf") {
            const blobUrl = createDataUrl(data.data.data.data, 'pdf')
            setTranslatedDataUrl(blobUrl);
            setLoading(false);
        } else {
            setTranslatedDataUrl(url);
            setLoading(false);
        }
    }
    const onViewDocError = (data) => {
        errorToast(data.data.message);
    }

    const getLangName = (value) => {
        let label = null;
        availableLanguages.forEach((itemdata) => {
            if (itemdata.value === value) {
                label = itemdata.label;
            }
        });
        return label;
    };

    const onClickDownload = async (data) => {
        const response = await fetch(data);
        const blob = await response.blob();

        const originalName = fileData?.file_name || "download";
        const lastDotIndex = originalName.lastIndexOf(".");

        const fileName =
            lastDotIndex !== -1
                ? originalName.substring(0, lastDotIndex)
                : originalName;

        const extension =
            lastDotIndex !== -1
                ? originalName.substring(lastDotIndex + 1)
                : "";

        saveAs(
            blob,
            `${fileName}_${getLangName(fileData?.target_lang)}${extension ? `.${extension}` : ""
            }`
        );
    };

    const uploadFileToGoogleDrive = async () => {
        try {
            setShowLoader(true)
            // Fetch the file from the URL
            const response = await fetch(translatedDataUrl);
            const fileBlob = await response.blob();

            const originalName = fileData?.file_name || "download";
            const lastDotIndex = originalName.lastIndexOf(".");

            const fileName =
                lastDotIndex !== -1
                    ? originalName.substring(0, lastDotIndex)
                    : originalName;

            const extension =
                lastDotIndex !== -1
                    ? originalName.substring(lastDotIndex + 1)
                    : "";

            const metadata = {
                name: `${fileName}_${getLangName(fileData?.target_lang)}${extension ? `.${extension}` : ""
                    }`,
                mimeType: fileBlob.type,
            };

            // Prepare the form data
            const form = new FormData();
            form.append(
                "metadata",
                new Blob([JSON.stringify(metadata)], { type: "application/json" })
            );
            form.append("file", fileBlob);

            // Send the file to Google Drive
            const uploadResponse = await fetch(
                "https://www.googleapis.com/upload/drive/v3/files?uploadType=multipart&fields=id",
                {
                    method: "POST",
                    headers: new Headers({
                        Authorization: `Bearer ${accessToken}`,
                    }),
                    body: form,
                }
            );
            const result = await uploadResponse.json();

            if (uploadResponse.ok) {
                console.log("File uploaded successfully. File ID:", result.id);
                setShowLoader(false)
                successToast("File Exported Successfully");
            } else {
                console.error("Error uploading file:", result.error);
                setShowLoader(false)
                errorToast('Unable to export file try again later');
            }
        } catch (error) {
            console.error("An error occurred during the file upload:", error);
            setShowLoader(false)
            errorToast('Unable to export file try again later');
        }
    };

    return (
        <TranslationLayout>
            <Container className="recents mx-3">
                {loading ? <Loading text={"Loading Preview"} /> :
                    <div className='uploading_div_translation d-md-flex w-100 gap-1'>
                        <div className='uploading '>
                            <div className='d-flex mx-4 justify-content-between align-content-center' style={{ position: 'relative' }}>
                                <Button variant={'primary'} className={`text-nowrap`}>
                                    <div className='fs_12'>
                                        {availableLanguages.map((itemdata) => {
                                            if (itemdata.value === fileData?.source_lang) {
                                                return itemdata.label;
                                            }
                                            return null;
                                        })}
                                    </div>
                                </Button>
                            </div>
                            {sourceFile && fileTypeRef.current === "pdf" || fileTypeRef.current === "html" ? <iframe title="File Preview" src={sourceFile} style={{ width: '90%', height: '100%', border: 'none' }} className='pt-3 pb-3' /> :
                                <DocFileViewer fileUrl={sourceFile} />
                            }
                        </div>
                        <div className='uploading'>
                            <div className='d-flex mx-4 justify-content-between align-content-center' style={{ position: 'relative' }}>
                                <Button variant={'success'} className={`text-nowrap`}>
                                    <div className='fs_12'>
                                        {availableLanguages.map((itemdata) => {
                                            if (itemdata.value === fileData?.target_lang) {
                                                return itemdata.label;
                                            }
                                            return null;
                                        })}
                                    </div>
                                </Button>
                                <div className='d-flex gap-2 w-100 justify-content-end align-items-center'>
                                    <div className="cursor_pointer mt-1">
                                        {!accessToken ?
                                            <div>
                                                <GoogleDrivePicker setAccessTokens={setAccessToken} type={"export"} />
                                            </div>
                                            :
                                            <ImGoogleDrive onClick={uploadFileToGoogleDrive} />
                                        }
                                    </div>
                                    <img src={downloadIcon} alt="download-icon" style={{ height: '16px' }} className="cursor_pointer px-2 mt-1" onClick={() => onClickDownload(translatedDataUrl)} />
                                </div>
                            </div>
                            {translatedDataUrl && fileTypeRef.current === "pdf" || fileTypeRef.current === "html" ? <iframe title="File Preview" src={translatedDataUrl} style={{ width: '90%', height: '100%', border: 'none' }} className='pt-3 pb-3' /> :
                                <TranslatedDocFileViewer fileUrl={translatedDataUrl} />
                            }
                        </div>
                    </div>
                }
                <LoaderModal show={showLoader} handleClose={() => setShowLoader(!showLoader)} text="Exporting..." />
            </Container>
        </TranslationLayout>
    )
}

export default PreviewDocuments
